import React, { Component } from "react";
import { Text, TouchableOpacity, View } from "react-native";
import chatstyles from "../styles/chatStyles";
import { CheckBox } from "react-native-elements";
import chatStyles from "../styles/chatStyles";
import styles from "../styles/styles";

export default class ChatCheckBox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isCheckBoxSelected: [false, false, false, false],
      selectedValue: [],
      selectedValuesArray: [],
    };
  }

  onCheckBoxSubmit() {
    if (!this.state.selectedValuesArray.length) {
      alert("Select at least one product to get the information!");
      return;
    }

    this.props.updateSentMessage(
      this.props.checkbox.length === this.state.selectedValuesArray.length
        ? "all"
        : this.state.selectedValuesArray.join(" and ")
    );
  }
  render() {
    return (
      <>
        <View style={chatstyles.checkBoxWrapper}>
          {this.props.checkbox.map((checkbox, i) => {
            return (
              <View
                key={`checkBoxKey${i}`}
                nativeID={`checkBoxKey${i}`}
                style={
                  this.state.isCheckBoxSelected[i]
                    ? [chatstyles.checkBoxView, chatstyles.backgroundOrange]
                    : chatstyles.checkBoxView
                }
              >
                <View style={chatstyles.row}>
                  <CheckBox
                    size={13.4}
                    title={checkbox.name}
                    containerStyle={{
                      backgroundColor: "transparent",
                      border: "none",
                      padding: 0,
                      borderWidth: 0,
                    }}
                    checked={this.state.isCheckBoxSelected[i]}
                    textStyle={
                      this.state.isCheckBoxSelected[i]
                        ? [chatstyles.checkBoxText, chatstyles.colorWhite]
                        : [chatstyles.checkBoxText]
                    }
                    checkedColor={
                      this.state.isCheckBoxSelected[i] ? "white" : "#f14d31"
                    }
                    uncheckedColor="#f14d31"
                    onPress={() => {
                      this.setState((state) => {
                        const isCheckBoxSelected = {
                          ...state.isCheckBoxSelected,
                        };
                        isCheckBoxSelected[i] = !isCheckBoxSelected[i];
                        const selectedValue = { ...state.selectedValue };
                        selectedValue[i] = isCheckBoxSelected[i]
                          ? checkbox.value
                          : "";

                        const selectedValuesArray = [];
                        Object.keys(selectedValue).forEach((each) => {
                          if (selectedValue[each]) {
                            selectedValuesArray.push(selectedValue[each]);
                          }
                        });

                        return {
                          isCheckBoxSelected,
                          selectedValue,
                          selectedValuesArray,
                        };
                      });
                    }}
                  />
                </View>
              </View>
            );
          })}
        </View>

        <View style={chatStyles.buttonsRow}>
          <View style={chatStyles.chatButtonCover}>
            <TouchableOpacity
              disableOptions={this.props.disableOptions}
              style={[
                chatStyles.chatButton,
                this.props.disableOptions ? styles.disabledOpacity : null,
              ]}
              onPress={() => {
                this.onCheckBoxSubmit();
              }}
            >
              <Text style={chatStyles.chatButtonText}>Get Details</Text>
            </TouchableOpacity>
          </View>

          <View style={chatStyles.chatButtonCover}>
            <TouchableOpacity
              style={[
                chatStyles.chatButton,
                this.props.disableOptions ||
                this.state.selectedValuesArray.length !== 0
                  ? styles.disabledOpacity
                  : null,
              ]}
              disabled={
                this.props.disableOptions ||
                this.state.selectedValuesArray.length !== 0
              }
              onPress={() => {
                this.props.updateSentMessage("No, Thanks");
              }}
            >
              <Text style={chatStyles.chatButtonText}>No, Thanks</Text>
            </TouchableOpacity>
          </View>
        </View>
      </>
    );
  }
}
